import { render, staticRenderFns } from "./Translator.vue?vue&type=template&id=4b1c50a7&scoped=true&"
import script from "./Translator.vue?vue&type=script&lang=js&"
export * from "./Translator.vue?vue&type=script&lang=js&"
import style0 from "./Translator.vue?vue&type=style&index=0&id=4b1c50a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c50a7",
  null
  
)

export default component.exports